import { ComponentProps } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

type HubFintechSupplementsArticlesProps = {
  /** The card props to be displayed in the component. */
  cardProps: ComponentProps<typeof Card>[];
  /** The class name to be applied to the component. */
  className?: string;
};

const HubFintechSupplementsArticles = ({
  cardProps,
  className,
}: HubFintechSupplementsArticlesProps): React.ReactElement => {
  if (cardProps.length === 0) return <></>;

  const variant: CardVariations = {
    image: {
      position: "right",
      width: "w-120px md:w-3/10",
      extraClass: "order-1 md:order-2",
    },
    content: {
      width: "w-full-120px md:w-7/10",
      extraClass: "order-2 pl-4 md:order-1 md:pr-4 md:pl-0",
    },
    kicker: {
      color: "text-gray-550",
      extraClass: cn("font-poppins text-4xs font-light leading-5"),
    },
    title: {
      size: "text-base",
      color: "text-gray-850",
      extraClass: cn("font-bold font-lct my-1"),
    },
  };

  return (
    <div
      className={className}
      data-testid="hub-property-supplements-articles-component"
    >
      <BlockTitle
        text="FINTECH SUPPLEMENTS"
        rootClassName="text-lg antialiased mb-4"
        link="/keywords/fintech"
      />

      <div className="stories divide-y divide-gray-175">
        {cardProps.map((cardProp, index) => {
          return (
            <Card
              key={cardProp.id}
              {...cardProp}
              className={cn("story pb-6 pt-6", {
                "pt-0": index === 0,
                "pb-0": index === cardProps.length - 1,
              })}
              variations={variant}
            />
          );
        })}
      </div>
    </div>
  );
};

export default HubFintechSupplementsArticles;
